import { SVGProps } from 'react';

export const TireStationSvg = ({ width = 123, height = 147, ...rest }: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 123 147' width={width} height={height} fill='none' {...rest}>
    <path
      fill='#1F1F1F'
      d='M117.859 103.066c2.442 1.403 2.455 3.68.025 5.083l-51.52 29.782c-2.43 1.403-6.379 1.403-8.822 0L5.69 108.149c-2.443-1.403-2.456-3.68-.026-5.083l51.52-29.782c2.43-1.403 6.38-1.403 8.822 0l51.86 29.782h-.006Z'
      opacity={0.1}
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m119.698 92.964-.019 5.874v.051c0 .045-.013.09-.013.128 0 .063-.012.127-.019.197v.032c-.013.038-.025.083-.038.128-.013.064-.032.12-.052.185 0 .012 0 .032-.012.038-.013.038-.039.077-.052.115-.032.063-.057.127-.089.191-.013.013-.013.032-.026.051-.013.032-.039.057-.058.089-.051.07-.096.147-.147.217-.013.019-.026.045-.045.064-.013.025-.039.045-.058.064a2.742 2.742 0 0 1-.263.28c-.025.026-.045.051-.07.07-.013.013-.026.02-.039.032a4.646 4.646 0 0 1-.192.16 2.626 2.626 0 0 1-.398.28 1.358 1.358 0 0 1-.166.109c-.026.013-.051.032-.071.044l-51.52 29.783a7.526 7.526 0 0 1-.59.3c-.057.025-.115.051-.18.07-.16.07-.32.127-.487.185-.038.012-.07.032-.109.044-.025 0-.05.013-.07.019-.11.032-.218.064-.32.09-.084.019-.16.044-.244.063-.11.032-.225.052-.34.077-.07.013-.135.032-.205.038h-.032c-.231.045-.468.077-.712.102h-.051c-.052.013-.11.013-.167.013-.14.013-.282.019-.417.032h-.737c-.051 0-.109-.013-.16-.013-.11 0-.212-.013-.32-.019h-.142c-.051 0-.096-.013-.147-.019-.11-.013-.212-.019-.314-.032-.052 0-.097-.013-.148-.013a1.32 1.32 0 0 0-.135-.025c-.108-.019-.224-.038-.326-.058-.052-.012-.11-.012-.154-.031-.039 0-.07-.013-.11-.026-.128-.032-.262-.057-.384-.089-.051-.013-.109-.032-.16-.045-.02 0-.039-.013-.052-.013-.23-.07-.455-.146-.673-.223-.013 0-.025-.013-.032-.013-.096-.032-.186-.076-.282-.121-.051-.025-.109-.044-.167-.07a7.866 7.866 0 0 1-.461-.242L5.669 101.363c-1.23-.707-1.846-1.632-1.84-2.557l.013-5.86c0 .924.615 1.849 1.84 2.55l51.86 29.783c.148.089.301.165.462.242.05.025.109.045.16.07.102.051.205.089.314.134.218.089.442.159.673.223l.212.058c.128.032.256.07.39.089.084.019.168.038.257.051.11.025.225.045.334.057.09.013.186.032.275.039.11.012.206.025.315.038.096.013.192.013.288.025.11 0 .205.013.314.013.077 0 .16 0 .231.013h.661c.147 0 .282-.019.422-.032.071 0 .148-.013.225-.019.237-.026.474-.058.711-.096.078-.013.154-.032.231-.051.116-.025.231-.051.347-.07.083-.025.166-.051.243-.07.11-.032.212-.057.32-.089.065-.02.122-.045.18-.064.167-.058.334-.115.494-.185.058-.032.122-.051.18-.077.205-.089.397-.185.59-.299l51.52-29.783c.089-.05.16-.102.237-.146l.224-.147c.064-.051.116-.09.173-.14.064-.051.128-.102.193-.16l.102-.102c.096-.09.186-.185.263-.28.032-.039.071-.083.103-.128a4.608 4.608 0 0 0 .23-.357.824.824 0 0 0 .09-.192c.026-.05.051-.101.071-.146.019-.064.032-.128.051-.185.013-.051.032-.109.038-.16.013-.07.02-.127.026-.197 0-.064.013-.121.013-.185l-.007-.007Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M117.859 90.407c2.442 1.403 2.455 3.68.025 5.083l-51.52 29.783c-2.43 1.403-6.379 1.403-8.822 0L5.69 95.49c-2.443-1.403-2.456-3.68-.026-5.083l51.52-29.782c2.43-1.403 6.38-1.403 8.822 0l51.86 29.782h-.006Z'
    />
    <path
      fill='#FBEBE6'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M35.038 46.537c0-1.518-.442-3.176-1.192-4.732-1.077-2.245-2.789-4.273-4.712-5.376-1.532-.88-2.936-1.014-3.982-.523L22.53 37.22c1.045-.479 2.436-.338 3.962.529 1.969 1.129 3.712 3.22 4.783 5.523.705 1.511 1.122 3.112 1.122 4.579 0 0 .27 2.487-2.064 4.942-.404.421-1.065 1.206-1.725 1.99-1.064 1.282-1.135 1.23-1.135 1.23l2.437-1.217c.14-.07.262-.166.365-.28.455-.53 1.84-2.13 2.706-3.05 2.333-2.455 2.07-4.942 2.07-4.942l-.013.013Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M32.39 47.857c0-3.711-2.64-8.24-5.904-10.101-1.526-.874-2.91-1.014-3.962-.53a1.046 1.046 0 0 1-.083.039c-.032.012-.065.032-.09.044-1.096.593-1.776 1.907-1.776 3.788 0 0-.27 2.181 2.064 7.309.686 1.511 2.122 4.904 3.026 7.053a1.253 1.253 0 0 0 2.123.306c.256-.312.525-.644.8-.969.661-.79 1.322-1.569 1.726-1.99 2.333-2.455 2.064-4.942 2.064-4.942l.013-.007Zm-3.346-1.103a2.946 2.946 0 0 1-.949-.363c-1.609-.919-2.91-3.144-2.91-4.975 0-.35.044-.65.134-.918.295.05.616.172.949.363 1.603.919 2.904 3.15 2.904 4.975 0 .344-.045.65-.134.918h.006Z'
    />
    <path
      fill='#FBEBE6'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M29.044 46.748a2.48 2.48 0 0 1-.135.325 1.434 1.434 0 0 1-.173.261.596.596 0 0 1-.102.115c-.11.109-.231.198-.366.262-.019.013-.038.019-.051.025-.045.02-.083.039-.135.051a.58.58 0 0 1-.14.039c-.02 0-.04.012-.058.012-.032.013-.07.013-.11.02h-.031a1.357 1.357 0 0 1-.167.012c-.391 0-.834-.127-1.302-.395-1.609-.919-2.91-3.15-2.91-4.974 0-.6.14-1.078.384-1.423.052-.076.11-.14.167-.204.064-.064.128-.114.199-.166.237-.165.526-.248.846-.248.116 0 .231.012.353.032a2.83 2.83 0 0 0-.135.918c0 1.83 1.302 4.056 2.91 4.974.334.192.655.313.95.364h.006ZM6.58 71.256v18.711l17.137 9.866V85.37L10.06 71.04l-3.481.217Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M43.61 76.95v11.43L23.716 99.832V85.369l2.078 2.181 17.816-10.6Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M37.103 82.123v6.237l3.809-2.187v-6.244l-3.809 2.194Z'
    />
    <path
      fill='#FBEBE6'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M39.924 85.675v-5.178l.987-.568v6.244l-.987-.498Z'
    />
    <path
      fill='#FBEBE6'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m39.924 85.675-2.82 1.633v1.052l3.808-2.187-.988-.498Z'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M38.372 86.575v-5.179M37.103 84.795l2.821-1.62'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M26.403 88.182v6.243l3.808-2.187v-6.244l-3.808 2.188Z'
    />
    <path
      fill='#FBEBE6'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M29.218 91.74v-5.178l.994-.568v6.244l-.994-.498Z'
    />
    <path
      fill='#FBEBE6'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m29.217 91.74-2.814 1.633v1.052l3.808-2.188-.994-.497Z'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M27.666 92.64v-5.185M26.403 90.86l2.814-1.62'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M30.955 85.516V95.61l5.391-3.1v-10.07l-5.391 3.075Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M32.391 89.177v.784l-.788.42v-.796l.788-.408Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m30.494 59.35 14.803 16.6-19.503 11.6-15.733-16.51 20.433-11.69ZM30.493 59.35l-7.104 1.084L3.527 71.447l6.533-.408 20.433-11.69Z'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M42.001 77.907 26.64 61.55l-6.79.848'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M38.276 80.127 22.748 63.775l-6.616.682'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M34.532 82.353 19.101 65.867l-6.508.555'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M30.512 84.635 15.145 68.131l-6.303.37'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M20.14 87.697v6.237l-3.809-2.187V85.51l3.808 2.187Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M17.318 91.255v-5.178l-.987-.567v6.237l.987-.492ZM17.318 91.256l2.821 1.626v1.052l-3.808-2.187.987-.491Z'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M18.87 92.155V86.97M20.139 90.376l-2.821-1.627'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M13.33 84.036v6.237l-3.814-2.187v-6.237l3.814 2.187Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M10.51 87.595v-5.178l-.994-.568v6.237l.993-.491Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m10.51 87.595 2.82 1.626v1.052l-3.814-2.187.993-.491Z'
    />
    <path
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M12.061 88.494V83.31M13.33 86.715l-2.82-1.627'
    />
    <path
      fill='#8063BB'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m106.222 91.052-14.207-8.163-6.418 3.954L97.56 93.71a.847.847 0 0 1 0 1.467l-8.232 4.732a1.362 1.362 0 0 1-1.359 0L67.075 87.908a9.688 9.688 0 0 0-9.649 0l-26.709 15.344 6.822 3.839 23.529-13.514c.73-.42 1.628-.42 2.36 0l20.303 11.664a9.854 9.854 0 0 0 9.822 0l12.028-6.913.641-.37c2.667-1.537 2.667-5.37 0-6.9v-.006Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M62.62 19.198v.006c-.007.026-.026.051-.039.077 0 0 0 .006-.006.012-.02.026-.039.051-.07.077-.02.013-.04.032-.065.045-.019.012-.032.025-.051.038-.051.032-.109.05-.167.076-.019.007-.045.013-.064.02-.026.006-.058.012-.083.019l-.103.019h-.025c-.045 0-.097.006-.142.006h-.025c-.045 0-.096 0-.141-.006h-.02c-.044 0-.09-.013-.134-.026h-.026c-.038-.012-.083-.019-.115-.038-.007 0-.013 0-.02-.006a.794.794 0 0 1-.127-.064c-.167-.096-.25-.223-.25-.35L60.881 61.9c0 .127.084.255.25.35.039.02.084.045.122.058h.007c.006 0 .012 0 .019.006.026.007.051.02.077.026.013 0 .025.006.045.012H61.453c.026 0 .058.013.083.013h.391c.026 0 .052 0 .07-.013.014 0 .02 0 .033-.006.032 0 .058-.013.083-.019a.119.119 0 0 0 .045-.013c.007 0 .013 0 .02-.006a.787.787 0 0 0 .166-.077h.013a.172.172 0 0 0 .038-.032c.02-.012.045-.032.064-.044.02-.02.039-.038.052-.058 0 0 0-.006.006-.012 0 0 0-.007.007-.013 0-.007.012-.013.019-.026.006-.012.02-.031.026-.05V61.983c0-.013.006-.02.006-.032V61.894l.064-42.798s0 .057-.013.089l-.006.013Z'
    />
    <path
      fill='#FBF5F0'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M62.383 18.758c.333.19.34.503 0 .695-.34.191-.872.191-1.206 0-.333-.192-.34-.504 0-.695.34-.192.872-.192 1.206 0Z'
    />
    <path
      fill='#8063BB'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M61.747 27.335c5.301 0 9.598-4.274 9.598-9.547 0-5.273-4.297-9.547-9.598-9.547-5.3 0-9.597 4.274-9.597 9.547 0 5.273 4.297 9.547 9.597 9.547Z'
    />
    <path
      fill='#ECE5FB'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M61.747 25.467c4.263 0 7.72-3.438 7.72-7.679 0-4.24-3.457-7.678-7.72-7.678s-7.719 3.438-7.719 7.678 3.456 7.679 7.72 7.679Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M59.863 21.806V14.42h2.77c.506 0 .948.089 1.34.274.39.185.692.446.91.79.218.345.327.766.327 1.263 0 .498-.11.906-.334 1.257a2.206 2.206 0 0 1-.91.797c-.385.185-.834.28-1.334.28h-1.416v2.724h-1.353Zm1.353-3.916h1.436c.243 0 .461-.051.64-.147.18-.095.321-.23.417-.401.097-.173.148-.37.148-.594 0-.223-.051-.433-.148-.6a1.08 1.08 0 0 0-.416-.394 1.34 1.34 0 0 0-.641-.147h-1.436v2.283Z'
    />
    <path
      fill='#8063BB'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M69.287 65.115V65.198c0 .012 0 .031-.006.044 0 .013 0 .026-.006.038 0 .013 0 .032-.013.045a.09.09 0 0 1-.013.038.118.118 0 0 1-.013.045c0 .013-.006.025-.013.038 0 .013-.012.032-.019.045 0 .013-.013.025-.02.038-.005.013-.012.032-.025.045 0 .013-.013.025-.019.038-.013.02-.02.038-.032.051-.006.013-.013.02-.02.032-.012.02-.025.038-.044.057 0 .007-.013.02-.02.026-.025.032-.05.064-.076.09-.007.006-.013.012-.02.025-.019.025-.044.044-.07.07l-.032.032a.275.275 0 0 1-.045.038l-.038.038c-.013.013-.032.026-.045.038a.194.194 0 0 1-.045.032c-.02.013-.032.026-.052.039-.012.012-.031.019-.044.032l-.058.038c-.026.013-.045.032-.07.044a2.097 2.097 0 0 1-.206.109c-.019.006-.038.019-.057.025-.065.032-.129.058-.193.083a.049.049 0 0 0-.025.013 8.15 8.15 0 0 1-.218.077c-.052.019-.103.031-.154.044a.772.772 0 0 1-.116.032c-.057.013-.109.026-.166.038-.039.007-.084.02-.122.026-.02 0-.032 0-.051.006-.071.013-.141.026-.212.032-.02 0-.038 0-.058.007a.788.788 0 0 0-.122.012l-.205.02H65.935c-.045 0-.097 0-.142-.013-.05 0-.102-.007-.154-.013-.044 0-.09-.013-.134-.02-.051-.006-.11-.018-.16-.025a.926.926 0 0 1-.129-.025c-.064-.013-.128-.026-.185-.045-.039-.013-.084-.019-.122-.032-.02 0-.045-.013-.064-.019l-.186-.057c-.02 0-.039-.013-.052-.02-.057-.019-.109-.044-.16-.063-.026-.013-.051-.02-.077-.032a1.487 1.487 0 0 1-.224-.115c-.603-.332-.904-.778-.91-1.23l.019 1.747c0 .446.307.893.91 1.23.07.039.147.077.224.115.026.013.052.02.077.032l.135.058a.433.433 0 0 1 .077.026l.186.057c.019 0 .045.012.064.019.013 0 .026.006.045.012l.077.02c.064.012.128.031.186.044.019 0 .032.007.05.013.027 0 .052.006.078.013.051.006.109.019.16.025.02 0 .045.007.064.013.026 0 .045 0 .07.006.052 0 .103.013.155.013.025 0 .044 0 .07.006h.666c.072 0 .136-.012.206-.019.026 0 .058 0 .083-.006h.039c.02 0 .038 0 .064-.006.07-.007.141-.02.212-.032.019 0 .032 0 .05-.007h.026c.033 0 .065-.013.097-.019l.166-.038c.039-.013.077-.02.116-.032.051-.013.102-.032.154-.045.013 0 .025 0 .032-.012.064-.02.121-.045.186-.07.006 0 .019-.007.025-.013.064-.026.129-.058.193-.083.019-.007.038-.02.057-.026.07-.032.135-.07.206-.108l.038-.02c.013-.006.02-.012.032-.018a.349.349 0 0 0 .051-.039c.02-.012.032-.019.045-.032.02-.012.032-.025.051-.038a.196.196 0 0 1 .045-.032c.013-.013.032-.025.045-.038l.039-.038c.013-.013.032-.026.045-.038 0 0 .012-.013.019-.013l.013-.013.07-.07a1.124 1.124 0 0 1 .096-.115c0-.006.013-.013.013-.02a.356.356 0 0 1 .045-.056c.006-.013.013-.02.02-.032.012-.02.019-.039.031-.051 0 0 0-.013.007-.013 0-.007.006-.013.013-.02.006-.012.012-.031.025-.044 0-.013.013-.025.02-.038.006-.013.012-.032.019-.045 0-.006 0-.013.006-.019v-.02c0-.012.007-.031.013-.044 0-.012.006-.025.013-.038 0-.013.006-.032.012-.045v-.045c0-.012 0-.031.007-.044V66.83l-.02-1.747v.05l.013-.018Z'
    />
    <path
      fill='#ECE5FB'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M68.377 63.833c1.199.663 1.218 1.766.051 2.468-1.167.695-3.084.727-4.283.063-1.198-.663-1.218-1.766-.05-2.468 1.166-.695 3.083-.727 4.282-.063Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M68.12 65.28a.974.974 0 0 1-.36.472c-.044.032-.095.07-.147.102-.365.217-.852.332-1.34.338-.198 0-.397-.012-.583-.044a2.495 2.495 0 0 1-.744-.255c-.256-.14-.423-.313-.506-.498a.637.637 0 0 1-.026-.484c.07-.204.237-.396.507-.555a2.375 2.375 0 0 1 .763-.28 3.13 3.13 0 0 1 1.577.095c.115.038.23.09.333.146.039.02.077.045.11.064.384.255.525.587.429.9h-.013Z'
    />
    <path
      fill='#1F1F1F'
      d='M66.306 67.538c-1.693.025-3.078-.797-3.097-1.824v-.026h.077c.038.97 1.391 1.741 3.013 1.716 1.622-.026 2.95-.835 2.962-1.805h.084v.032c.012 1.033-1.347 1.894-3.04 1.913v-.006Z'
    />
    <path
      fill='#1F1F1F'
      d='M66.306 68.17c-1.693.025-3.078-.798-3.097-1.825v-.025h.077c.038.97 1.391 1.74 3.013 1.715 1.622-.025 2.95-.835 2.962-1.804h.084v.031c.012 1.034-1.347 1.894-3.04 1.914v-.007ZM64.991 65.892c.103.051.218.102.334.134.173-.12.423-.204.705-.217.365-.012.692.096.859.268.148-.032.288-.076.423-.134a.415.415 0 0 1-.032-.127c-.013-.294.353-.555.834-.606a.622.622 0 0 0-.039-.478 1.406 1.406 0 0 1-.34.05c-.532.02-.974-.216-.987-.535 0-.083.02-.16.07-.23a3.462 3.462 0 0 0-.576-.031c-.045.286-.443.523-.937.542a1.52 1.52 0 0 1-.525-.07c-.18.146-.295.312-.34.478.372.063.641.261.648.51 0 .134-.071.261-.2.37.033.019.071.044.11.064l-.007.012Zm.936-.733c.007-.032.032-.064.07-.096a.576.576 0 0 1 .295-.096h.116a.497.497 0 0 1 .148.045.215.215 0 0 1 .102.096c.013.032.02.064.007.096a.227.227 0 0 1-.097.114.304.304 0 0 1-.064.032c-.025.013-.057.02-.083.026a.583.583 0 0 1-.314-.013c-.026-.006-.045-.02-.064-.025-.007 0-.013-.007-.02-.013-.076-.051-.108-.115-.09-.179l-.006.013Z'
    />
    <path
      fill='#1F1F1F'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M85.059 87.378c-.443.255-.513 2.819-.225 3.54l1.244-.734a1.416 1.416 0 0 1 1.43-.006l4.622 2.646s-2.167-5.503-1.724-5.765l-5.347.325v-.006Z'
    />
    <path
      fill='#444'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M86.206 88.59s.039-.013.051-.02c.013 0 .032-.012.045-.012.02 0 .039-.013.058-.02.02 0 .032-.006.051-.012.02 0 .039-.007.058-.013.02 0 .032 0 .051-.006.02 0 .039 0 .058-.007h.282c.026 0 .051 0 .077.007h.051c.032 0 .058.012.09.019.013 0 .026 0 .038.006l.148.039c.013 0 .026.006.038.012l.116.039c.02.006.032.012.051.019.02.006.045.019.064.025.02.007.039.02.064.026.02.013.045.019.07.032.02.012.046.019.065.031.026.013.045.026.07.039.02.013.045.025.065.038a.431.431 0 0 1 .07.045c.026.019.058.038.084.057a2.695 2.695 0 0 1 .288.223c.064.058.135.115.199.172.006.007.019.013.025.026.07.064.135.134.206.204l.134.153c.032.038.07.077.103.115.045.057.09.115.134.166.032.038.064.083.097.12a4.378 4.378 0 0 1 .186.268c.012.02.025.045.038.064l.077.134c.045.07.083.147.128.224l.077.146c.032.064.064.121.09.185.026.051.051.102.07.16.026.057.052.115.077.178.02.058.045.109.064.166l.065.179c.019.05.038.108.05.165.02.064.04.128.058.198l.039.153c.02.077.032.16.051.236.013.051.02.102.032.153 0 .026.007.058.013.083.013.083.02.16.032.242 0 .026 0 .045.007.07 0 .07.006.147.012.218v.108c0 .108 0 .21-.012.312-.065.861-.41 1.442-.924 1.684l1.994-.95c.513-.243.86-.823.924-1.684.006-.102.012-.204.012-.312v-.109c0-.064 0-.12-.006-.185v-.032c0-.025 0-.044-.007-.07-.006-.083-.019-.16-.032-.242a.372.372 0 0 0-.012-.083c0-.02 0-.038-.007-.057 0-.032-.013-.064-.02-.096a3.06 3.06 0 0 0-.05-.236.225.225 0 0 0-.013-.064c-.007-.032-.02-.064-.026-.09a7.48 7.48 0 0 1-.077-.273.442.442 0 0 0-.032-.083c-.019-.058-.038-.121-.064-.179-.013-.025-.02-.057-.032-.083-.013-.025-.02-.05-.032-.076l-.077-.179c-.013-.032-.026-.057-.038-.09-.013-.025-.026-.044-.032-.07-.032-.063-.058-.127-.09-.184-.013-.032-.032-.064-.045-.09a.14.14 0 0 0-.032-.05c-.039-.077-.084-.147-.128-.224-.02-.032-.032-.057-.052-.089-.006-.013-.019-.025-.025-.045-.013-.019-.026-.044-.045-.063a2.58 2.58 0 0 0-.148-.217c-.013-.02-.025-.038-.038-.051 0-.007-.013-.02-.02-.026l-.076-.095c-.045-.058-.09-.115-.135-.166a209.844 209.844 0 0 1-.237-.268l-.032-.032-.173-.172c-.007-.007-.02-.013-.026-.026-.064-.057-.135-.114-.199-.172-.019-.019-.038-.032-.057-.05-.077-.058-.154-.122-.231-.173-.013-.013-.032-.02-.045-.032-.013-.006-.026-.02-.045-.025-.026-.013-.045-.032-.07-.045-.02-.013-.045-.026-.065-.038l-.07-.039c-.02-.012-.039-.019-.064-.031-.026-.013-.045-.026-.07-.032a.193.193 0 0 0-.065-.026c-.02-.013-.045-.019-.064-.025a.049.049 0 0 1-.026-.013c-.006 0-.019 0-.025-.007l-.116-.038c-.013 0-.025-.006-.038-.013-.051-.012-.096-.025-.148-.038h-.032c-.032 0-.057-.013-.09-.019h-.05c-.026 0-.052 0-.078-.006H88.578c-.019 0-.038 0-.057.006-.02 0-.032 0-.052.006-.019 0-.038.007-.057.013-.013 0-.02 0-.033.007h-.019c-.019 0-.038.012-.057.019-.013 0-.032.013-.045.013a.427.427 0 0 0-.052.019c-.012 0-.019.006-.032.012-.013 0-.019.007-.032.013l-1.994.95s.039-.019.065-.025l-.007-.02Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M85.22 90.292c.127-1.703 1.378-2.308 2.794-1.358 1.417.957 2.456 3.106 2.328 4.808-.129 1.703-1.379 2.315-2.796 1.359-1.416-.957-2.461-3.106-2.333-4.815l.006.006Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M87.008 89.82c.218-.031.468.02.73.16.065.032.129.07.193.115.449.3.834.79 1.096 1.34.11.222.193.452.257.688.09.331.128.67.102.976-.025.363-.134.644-.301.841a.82.82 0 0 1-.538.287c-.27.032-.578-.057-.904-.274a3.014 3.014 0 0 1-.725-.714c-.391-.536-.667-1.205-.724-1.837a2.674 2.674 0 0 1-.007-.453c0-.057.013-.108.02-.159.083-.568.39-.906.807-.963l-.006-.006Z'
    />
    <path
      fill='#1F1F1F'
      d='M90.547 90.688c.923 1.9.718 3.903-.456 4.464l-.025.013-.026-.045-.013-.025-.012-.02c1.09-.554 1.256-2.493.378-4.317-.885-1.824-2.507-2.895-3.629-2.398l-.045-.089.032-.02c1.173-.56 2.873.53 3.796 2.43v.007Z'
    />
    <path
      fill='#1F1F1F'
      d='M91.271 90.35c.924 1.9.718 3.903-.455 4.464l-.026.013-.025-.044-.013-.026-.013-.02c1.09-.554 1.257-2.493.379-4.317-.885-1.824-2.507-2.895-3.63-2.398l-.044-.089.032-.019c1.173-.561 2.872.53 3.795 2.43v.006ZM89.36 93.041a2.7 2.7 0 0 0-.019-.453c-.23-.127-.455-.37-.615-.682-.212-.408-.257-.829-.148-1.116a3.238 3.238 0 0 0-.372-.408.395.395 0 0 1-.128.102c-.333.172-.82-.108-1.135-.631a.827.827 0 0 0-.525.293c.09.102.166.223.237.357.308.593.269 1.218-.09 1.403a.53.53 0 0 1-.301.045c.064.23.16.453.269.67.353-.096.833.229 1.115.777.11.21.174.428.2.632.262.127.512.172.724.134-.122-.453-.032-.861.243-1.002.154-.076.34-.057.526.032a1.22 1.22 0 0 0 .013-.16l.006.007Zm-1.333-.67a.25.25 0 0 1-.148-.025c-.013 0-.025-.013-.038-.019a.646.646 0 0 1-.225-.261c-.019-.045-.038-.09-.05-.134a.51.51 0 0 1-.026-.192c0-.07.025-.127.057-.166a.167.167 0 0 1 .103-.057.26.26 0 0 1 .18.051.199.199 0 0 1 .07.058.707.707 0 0 1 .23.446v.121c-.012.115-.07.185-.153.198v-.02Z'
    />
    <path
      fill='#1F1F1F'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M64.088 74.368c-.442.255-.513 2.819-.224 3.54l1.243-.734a1.416 1.416 0 0 1 1.43-.006l4.622 2.646s-2.167-5.503-1.724-5.765l-5.347.326v-.007Z'
    />
    <path
      fill='#444'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M65.319 76.588s.038-.013.051-.02c.013 0 .032-.012.045-.012.02 0 .039-.013.058-.02.019 0 .032-.006.051-.012.02 0 .039-.007.058-.013.019 0 .032 0 .051-.006.02 0 .038 0 .058-.007H65.972c.027 0 .052 0 .078.007h.051c.032 0 .058.012.09.019.013 0 .025 0 .038.006.052.013.097.026.148.038a.09.09 0 0 1 .038.013l.116.038.05.02c.02.006.046.019.065.025.02.006.038.02.064.025.02.013.045.02.07.032.02.013.046.02.065.032l.07.039c.02.012.045.025.064.038a.431.431 0 0 1 .071.044c.026.02.058.039.083.058a2.695 2.695 0 0 1 .289.223c.064.058.134.115.199.172.006.007.019.013.025.026.07.064.135.134.205.204l.135.153c.032.038.07.076.103.115.044.057.09.114.134.165.032.039.064.083.096.122.013.019.026.038.039.05.051.07.102.147.147.217.013.02.026.045.039.064l.077.134c.045.07.083.147.128.223.026.052.051.096.077.147.032.064.064.121.09.185.025.051.05.102.07.16.026.057.051.114.077.178.02.058.045.109.064.166.02.057.045.121.064.178.02.052.039.109.052.166.019.064.038.128.057.198l.039.153c.019.076.032.16.051.236.013.051.02.102.032.153 0 .026.007.057.013.083.013.083.02.16.032.242 0 .026 0 .045.006.07 0 .07.007.147.013.217v.109c0 .108 0 .21-.013.312-.064.861-.41 1.442-.923 1.684l1.994-.95c.513-.243.86-.823.923-1.684.007-.102.013-.204.013-.313v-.108c0-.064 0-.121-.006-.185v-.032c0-.025 0-.044-.007-.07-.006-.083-.019-.16-.032-.242a.372.372 0 0 0-.013-.083c0-.02 0-.038-.006-.058 0-.032-.013-.063-.02-.095a3.06 3.06 0 0 0-.05-.236.226.226 0 0 0-.013-.064c-.007-.032-.02-.064-.026-.09a7.371 7.371 0 0 1-.077-.273.442.442 0 0 0-.032-.083c-.02-.058-.038-.122-.064-.179-.013-.025-.02-.057-.032-.083-.013-.025-.02-.05-.032-.076-.026-.058-.051-.122-.077-.179-.013-.032-.026-.057-.039-.09-.012-.025-.025-.044-.032-.07-.032-.063-.057-.127-.09-.184-.012-.032-.031-.064-.044-.09a.14.14 0 0 0-.032-.05c-.039-.077-.084-.147-.129-.224-.019-.032-.032-.057-.05-.09-.007-.012-.02-.025-.026-.044-.013-.019-.026-.044-.045-.064-.045-.076-.097-.146-.148-.216-.013-.02-.026-.039-.038-.051 0-.007-.013-.02-.02-.026l-.076-.096c-.045-.057-.09-.114-.135-.165a1.682 1.682 0 0 0-.103-.115l-.134-.153-.032-.032-.173-.172c-.007-.007-.02-.013-.026-.026-.064-.057-.135-.115-.199-.172-.02-.02-.038-.032-.058-.051-.077-.057-.154-.121-.23-.172-.013-.013-.032-.02-.045-.032-.013-.006-.026-.02-.045-.026-.026-.012-.045-.031-.07-.044-.02-.013-.046-.026-.065-.038-.026-.013-.045-.026-.07-.039-.02-.013-.039-.019-.064-.032-.026-.012-.045-.025-.071-.032a.193.193 0 0 0-.064-.025c-.02-.013-.045-.02-.064-.026a.049.049 0 0 1-.026-.012c-.006 0-.02 0-.025-.007l-.116-.038c-.013 0-.026-.006-.038-.013l-.148-.038h-.032c-.032 0-.058-.013-.09-.02h-.05c-.027 0-.052 0-.078-.005H67.691c-.02 0-.038 0-.058.006-.019 0-.032 0-.05.006a.187.187 0 0 0-.059.013c-.012 0-.019 0-.032.006h-.019c-.02 0-.038.013-.058.02-.012 0-.032.012-.044.012a.427.427 0 0 0-.052.02c-.013 0-.019.006-.032.012-.013 0-.02.007-.032.013l-1.994.95s.039-.019.064-.025l-.006-.02Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M64.332 78.29c.128-1.703 1.378-2.309 2.795-1.358 1.417.956 2.455 3.105 2.327 4.808-.128 1.703-1.378 2.315-2.795 1.359-1.417-.957-2.462-3.106-2.334-4.815l.007.006Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M66.114 77.818c.218-.032.468.02.73.16.065.032.129.07.193.115.449.3.833.79 1.096 1.339.11.223.193.453.257.689.09.331.128.67.102.975-.025.364-.134.644-.301.842a.82.82 0 0 1-.539.287c-.269.032-.577-.057-.903-.274a3.016 3.016 0 0 1-.725-.714c-.391-.536-.667-1.206-.725-1.837a2.684 2.684 0 0 1-.006-.453c0-.057.013-.108.02-.16.083-.567.39-.905.807-.962l-.006-.007Z'
    />
    <path
      fill='#1F1F1F'
      d='M69.66 78.685c.923 1.9.718 3.903-.456 4.465l-.025.012-.026-.044-.013-.026-.013-.019c1.09-.555 1.257-2.493.379-4.317-.879-1.824-2.507-2.896-3.63-2.398l-.044-.09.032-.019c1.173-.561 2.872.53 3.795 2.43v.006Z'
    />
    <path
      fill='#1F1F1F'
      d='M70.384 78.347c.923 1.901.718 3.904-.455 4.465l-.026.012-.025-.044-.013-.026-.013-.019c1.09-.555 1.257-2.493.378-4.317-.885-1.824-2.507-2.896-3.629-2.398l-.044-.09.032-.019c1.173-.56 2.872.53 3.795 2.43v.007ZM68.467 81.038c.006-.146 0-.3-.02-.452-.23-.128-.455-.37-.615-.683-.212-.408-.256-.829-.147-1.116a3.238 3.238 0 0 0-.372-.408.395.395 0 0 1-.129.102c-.333.172-.82-.108-1.134-.631a.826.826 0 0 0-.526.293c.09.102.167.223.237.357.308.593.27 1.218-.09 1.403a.53.53 0 0 1-.3.045c.063.23.16.453.268.67.353-.096.834.23 1.116.778.109.21.173.427.199.631.263.128.513.172.724.134-.122-.453-.032-.861.244-1.001.154-.077.34-.058.526.032.006-.051.012-.102.012-.16l.007.007Zm-1.334-.67a.251.251 0 0 1-.147-.025c-.013 0-.026-.012-.039-.019a.645.645 0 0 1-.224-.261 1.13 1.13 0 0 1-.051-.134.51.51 0 0 1-.026-.191c0-.07.026-.128.058-.166a.167.167 0 0 1 .102-.058.26.26 0 0 1 .18.051.2.2 0 0 1 .07.058.708.708 0 0 1 .23.446l.001.09v.031c-.013.115-.07.185-.154.198v-.02Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M104.606 85.254s-.243-1.747-.384-2.136c-.148-.383-.86-1.333-.86-1.333l-5.75-5.293-4.328-6.588s-.308-.344-.692-.759c.019-.108-1.943-2.187-5.488-4.337h-.007a71.904 71.904 0 0 0-3.013-1.843 11295.17 11295.17 0 0 1-10.027-5.759l-10.72 6.155c.122.14 7.816 8.909 10.867 10.133.039.013.077.032.116.045l9.585 8.877s6.167 5.408 6.282 5.58c.058.077.68 1.518 1.353 3.08.82 1.908 1.706 3.987 1.706 3.987l4.981-2.857 6.097-3.502h.007l.705-1.275v-1.352l-.436-.804.006-.019Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m95.714 91.007-.609-.083c.064-.236-.256-.306-.038-.415.365-.172 2.27-1.033 2.27-1.033s4.506-2.66 4.776-2.882c.147-.128 1.224-1.046 1.372-1.168.096-.082.256.204.307.32l-.442.656-1 .804-5.482 3.303-1.154.498Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m104.215 83.118-11.097 6.37-7.732-5.981 12.22-7.015 5.75 5.293.859 1.333Z'
    />
    <path
      fill='#FBEBE6'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M93.707 92.556v1.353l-.468 1.154-1.91-.128-.86-.414-.224-.14v-1.072c0-.906-.34-1.926-.885-2.812-.494-.804-1.154-1.505-1.878-1.92-1.02-.587-1.91-.465-2.385.198-.238.325-.372.79-.372 1.364 0 .185.013.37.038.562v.3l-.102-.064-.02-.013-1.032-.753-13.207-7.882-1.103-.523-.07-.051v-.472c0-.223-.02-.46-.064-.689-.263-1.575-1.372-3.278-2.693-4.043-1.48-.848-2.692-.21-2.757 1.435l-1.18-.81-.692-.472-.346-.708-.346-1.626v-1.193h.365l.75-5.956.66-3.38.379-.447c.173.102 5.783 3.323 10.02 5.76 4.309 2.474 6.226 4.361 6.86 4.916.629.549 1.597 2.462 1.597 2.462l3.578 7.021 6.443 5.179 1.295.797c.14.383.385 2.136.385 2.136l.205.931h.019Z'
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M70.428 81.925c0 .128 0 .243-.013.358l-.295-.039-.801-.478-.07-.051v-.472c0-1.741-1.231-3.858-2.757-4.732-.744-.427-1.417-.478-1.91-.217-.495.255-.815.83-.847 1.652l-1.18-.81c.026-.472.122-.886.27-1.237.14-.326.333-.593.564-.797.724-.638 1.846-.67 3.103.057 2.173 1.25 3.942 4.28 3.942 6.766h-.006Z'
    />
    <path
      fill='#1F1F1F'
      stroke='#000'
      strokeMiterlimit={10}
      strokeWidth={0.442}
      d='M82.93 88.538a.86.86 0 0 1-.43-.133l-6.789-3.903s-.506-.53-.506-.931l.154-5.453.532-5.274a.15.15 0 0 1 .07-.134c.045-.026.103-.02.154.013l.449.255c1.59.899 2.705 1.734 3.308 2.474.968 1.186 3.417 6.588 3.52 6.817l.423 1.066v1.632l-.141 2.71c0 .032-.116.625-.507.804a.61.61 0 0 1-.237.051v.007Zm-7.13-4.132 6.771 3.884c.212.12.391.146.545.076.327-.153.43-.695.43-.701l.14-2.698v-1.62l-.41-1.02c-.051-.108-2.551-5.618-3.5-6.786-.596-.733-1.7-1.556-3.276-2.442l-.45-.255-.025-.007v.026l-.532 5.274-.154 5.446c0 .326.41.772.462.83v-.007Z'
      style={{
        mixBlendMode: 'multiply'
      }}
    />
    <path
      fill='#DD6C54'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M91.432 93.985c0 .344-.032.663-.097.95l-.859-.414-.224-.14v-1.072c0-.905-.34-1.926-.885-2.812-.493-.804-1.154-1.505-1.878-1.92-1.52-.874-2.757-.178-2.757 1.563 0 .184.013.37.038.56v.3l-.121-.076-1.033-.753c-.038-.28-.07-.433-.07-.707 0-2.488 1.763-3.489 3.936-2.233 1.36.779 2.558 2.252 3.264 3.853.43.962.68 1.976.68 2.907l.006-.006Z'
    />
    <path
      fill='#fff'
      d='m75.019 72.984-.32 2.927c.038.402-.052.695-.264.83a.515.515 0 0 1-.288.082c-.135 0-.314-.044-.526-.166l-9.661-5.541c-.379-.217-.462-.523-.385-1.43l.32-2.952c.032-.37.186-.663.417-.784a.54.54 0 0 1 .378-.051l1.238.663 8.052 4.61c.5.288.956 1.072 1.039 1.78v.032Z'
    />
    <path
      fill='#1F1F1F'
      d='M75.019 72.965v-.013c-.083-.707-.538-1.492-1.039-1.779l-8.052-4.61-.994-.568a.794.794 0 0 0-.243-.096.508.508 0 0 0-.379.051c-.23.121-.39.415-.416.784l-.32 2.953c-.072.912.012 1.218.384 1.429l9.661 5.542c.218.12.392.165.526.165a.515.515 0 0 0 .289-.082c.211-.134.3-.434.262-.83l.321-2.927v-.019Zm-.615 2.934v.032c.032.287-.02.497-.129.574-.102.07-.288.038-.513-.096l-9.661-5.536c-.205-.12-.32-.23-.244-1.154l.32-2.953c.02-.267.122-.484.27-.554a.265.265 0 0 1 .122-.032.48.48 0 0 1 .218.07l9.046 5.178c.41.236.814.944.891 1.544l-.32 2.933V75.9Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m96.778 77.742.173-.332c.103-.204.16-.427.167-.65-.083-.147-.212-.351-.365-.6h-.045l-1.917-.49-4.347 2.601-.673 1.722-4.373 2.475.122.242a.823.823 0 0 0 .891.427c.59-.121 1.404-.287 1.436-.274 0 0 2.956-1.116 5.078-2.379 2.34-1.384 3.847-2.742 3.847-2.742h.006Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M92.566 89.062c-.512-.338-7.18-5.555-7.18-5.555l-3.578-7.022s-.538-1.638-2.423-3.258c-2.25-1.933-6.033-4.114-6.033-4.114l-10.027-5.758-.378.452s9.463 5.344 11.501 6.524c2.04 1.174 3.924 2.717 4.649 3.285.724.567 1.859 1.709 2.244 2.519.384.81 3.615 7.697 3.673 7.767.058.07 6.495 4.956 6.495 4.956l.852.637.372.147 1.18-.306c-.725.064-.904.02-1.347-.268v-.006Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M104.215 83.118c0-.05 0-.083-.007-.108-.038-.077-.359-.657-.519-.772.218.306.526.886.526.886l-.635.683s-1.167.854-4.212 2.73c-3.039 1.874-5.488 2.805-5.488 2.805l-.75.179c.038.09.27.28 1.712-.204 2.865-1.084 7.007-3.814 8.334-4.809 1.334-.988 1.064-1.077 1.039-1.396v.006Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m104.215 83.124-.007-.115c.02.121.09.485.007.115Z'
    />
    <path
      fill='#8063BB'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M93.508 91.625s.988-.115 1.296-.198c.307-.083.916-.42.916-.42l-.192-1.014s-.308-.262-.532-.275c-.378.16-1.872-.23-1.872-.23s-.276.013-.494-.006c-.218-.025-.583.255-.583.255s-.058.817 0 1.27c.057.452 1.461.618 1.461.618Z'
    />
    <path
      fill='#8063BB'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M93.136 89.578c-.275-.025-.59 0-.59 0s-.359.134-.39.185c-.039.058-.071 1.027 0 1.212.07.185.32.28.576.357.257.07.392.096.392.096l.34.025-.154-1.766-.174-.109ZM104.6 85.254l-.141.332-1.103.823c-.185-1.327-.134-.938-.134-.938s.045-.446.109-.523c.058-.057.583-1.237.833-1.69.058-.108.045-.16.045-.242.083.223.244.886.398 2.238h-.007Z'
    />
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='M104.254 83.118s0 .178-.116.293c.064.07.09.115.148.37.141.606.186 1.652.186 1.652l.064-.064.07-.115v-.115l-.205-1.55-.141-.471h-.006ZM96.163 92.875c-.41.287-.545.817-.558 1.002-.013.178 1.757-.76 2.206-1.033.448-.275 3.891-2.303 5.007-3.055 1.115-.746.91-.663 1.013-.83.102-.165.262-.656.211-.777-.051-.121-.308.12-.308.12s-5.366 3.661-7.571 4.573ZM62.158 68.163s-.013.236.14.332c.058.057.065.261.065.261l-.289 2.596-.243 2.155s-.263-.172-.27-.612c.058-.561.597-4.738.597-4.738v.006ZM96.945 77.41l-.173.332s-1.507 1.358-3.847 2.742c-2.122 1.256-5.077 2.373-5.077 2.373-.032-.013-.847.153-1.436.274a.819.819 0 0 1-.898-.428l-.353-.688-2.968-5.766-.308-.535a.375.375 0 0 1 .225-.549c.756-.204 2.27-.67 3.468-1.345l6.757-3.801.302-.262a.242.242 0 0 1 .352.032l.141.179 3.501 5.523.25.395a1.52 1.52 0 0 1 .07 1.505l-.006.02Z'
    />
    <g fill='#1F1F1F' opacity={0.2}>
      <path d='M94.503 75.67c-.052-.836-.815-1.174-1.84-.74-1.135.484-2.16 1.734-2.29 2.786a1.29 1.29 0 0 0 .046.6c.038.12.102.23.18.319.313.35.897.427 1.602.12 1.039-.44 1.988-1.523 2.238-2.512a1.46 1.46 0 0 0 .05-.274 2.4 2.4 0 0 0 .014-.3Zm-1.834-.409c.07-.032.135-.045.199-.07l-.257 1.052-.154.612-.525-.102-.814-.153c.371-.567.942-1.078 1.545-1.339h.006Zm-.404 3.29c-.712.3-1.282.173-1.487-.273-.02-.045-.039-.09-.052-.134-.038-.14-.05-.3-.032-.479.032-.274.141-.555.295-.835l.731.14.86.166.063.013.013-.051.25-1.014.237-.95c.545-.09.95.12 1.071.554.039.134.051.294.032.472-.006.064-.019.128-.032.192-.205.86-1.032 1.817-1.936 2.206l-.013-.006Z' />
      <path d='m96.945 77.41-.173.332s-1.506 1.358-3.846 2.742c-2.123 1.256-5.078 2.372-5.078 2.372-.032-.012-.846.153-1.436.275a.819.819 0 0 1-.898-.428l-.352-.689a38.051 38.051 0 0 1 5.257-3.711c.102-.064.205-.121.308-.179a31.863 31.863 0 0 1 1.846-1.001c.02-.013.045-.032.07-.038a34.76 34.76 0 0 1 1.558-.746c.077-.032.154-.07.231-.102.32-.14.641-.275.968-.402.295-.121.59-.236.891-.344a.462.462 0 0 1 .334.012l.25.396a1.52 1.52 0 0 1 .07 1.505v.006Z' />
      <path d='M95.406 75.841c-.211 1.55-3.59 4.241-4.936 3.08 0 0 .59-1.562 1.814-2.461 1.757-1.282 3.122-.619 3.122-.619Z' />
    </g>
    <path
      fill='#fff'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m76.301 77.71.295-3.66 2.353 1.453c.295.179.526.447.667.76a677.133 677.133 0 0 0 2.128 4.801l-5.45-3.354h.007Z'
    />
    <path
      fill='#1F1F1F'
      d='m66.98 68.558-.68-.389-.02.192c.116.064.231.49.148 1.326l-.013.096-.462-1.811-.775-.447-.02.192c.116.064.174.319.071 1.313-.103.995-.199 1.161-.32 1.091l-.02.191.667.383.02-.191c-.11-.064-.232-.491-.148-1.34l.057-.529.59 2.353.41.236.142-1.39c.102-.989.198-1.16.32-1.09l.02-.192M67.678 71.677c-.167-.096-.225-.294-.116-1.308.11-1.014.193-1.128.36-1.033.166.096.217.294.115 1.308-.103 1.014-.193 1.128-.353 1.033m.27-2.602c-.59-.338-.981.025-1.078.905-.096.88.186 1.627.776 1.965.59.338.981-.026 1.07-.906.09-.88-.191-1.633-.775-1.964M69.448 72.685l.237-2.322.077.045c.205.121.276.383.18 1.333-.097.95-.212 1.103-.417.988l-.077-.044Zm.404-2.475-.923-.53-.02.192c.116.064.116.287.013 1.282-.102.995-.147 1.193-.263 1.123l-.019.19.987.568c.565.326.924-.102 1.007-.892.083-.791-.16-1.57-.789-1.926M71.365 73.781l.237-2.321.077.045c.205.12.275.382.18 1.333-.097.95-.212 1.103-.418.988l-.076-.045Zm.403-2.474-.923-.53-.02.192c.116.064.116.287.014 1.282-.103.995-.148 1.192-.263 1.122l-.02.191.988.568c.564.325.93-.096 1.007-.893.076-.797-.16-1.569-.79-1.926M73.66 72.398l-.898-.517-.02.191c.116.064.11.294.014 1.276-.097.982-.141 1.192-.257 1.122l-.019.192.897.516.02-.191c-.122-.07-.116-.293-.013-1.282.103-.989.141-1.192.263-1.122l.02-.192M92.2 83.826l-.685.395.14.16c.116-.064.526.127 1.148.816l.077.083-1.712-.855-.782.453.141.16c.116-.07.353.057 1.097.88.743.822.82 1.039.698 1.11l.141.159.68-.39-.141-.159c-.109.064-.52-.121-1.16-.823l-.398-.44 2.218 1.123.417-.243-1.045-1.154c-.744-.816-.827-1.033-.705-1.103l-.141-.16M95.085 85.388c-.173.096-.358 0-1.115-.829s-.802-1.007-.635-1.103c.167-.096.36 0 1.11.83.75.828.807 1.007.634 1.102m-1.949-2.155c-.596.338-.513 1.001.141 1.722.654.72 1.417.988 2.007.65.59-.338.52-1.001-.135-1.722-.654-.72-1.417-.988-2.013-.65ZM96.874 84.348l-1.737-1.92.083-.044c.205-.121.462 0 1.174.784.698.772.769 1.02.564 1.136l-.084.044Zm-1.763-2.194-.93.536.142.16c.115-.07.295.095 1.032.918.737.823.878 1.008.763 1.071l.14.16 1.001-.574c.57-.325.43-.995-.167-1.658-.602-.67-1.346-.976-1.98-.612ZM98.81 83.239l-1.737-1.92.084-.044c.205-.122.461 0 1.173.784.712.785.77 1.02.564 1.135l-.083.045Zm-1.762-2.194-.93.536.141.16c.116-.07.295.095 1.039.911.743.817.878 1.008.763 1.072l.14.159 1-.574c.572-.325.43-.995-.166-1.652-.596-.657-1.346-.975-1.98-.612M98.965 79.942l-.91.523.14.16c.116-.07.302.101 1.039.911.737.81.878 1.008.763 1.072l.141.16.91-.524-.141-.16c-.122.07-.301-.095-1.038-.911-.738-.817-.885-1.002-.757-1.072l-.141-.16'
    />
    <path
      fill='#444'
      stroke='#1F1F1F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.883}
      d='m30.955 95.611 6.52 3.75 5.328-3.06-6.457-3.789-5.391 3.1Z'
    />
  </svg>
);
